import StdAnimations from '../StdAnimations.js';


export default function AboutHeadModule(element) {
    let tl = gsap.timeline({});
    let qs  = element.querySelector.bind(element);
    let qsa = element.querySelectorAll.bind(element);

    tl.from(qs('.abouthead__title'), StdAnimations.appearingTitle);
    tl.from(qs('.abouthead__intro'), StdAnimations.appearingTitle, '<0.3');

    qsa('.abouthead__figure').forEach(function(numberElm) {
        tl.from(numberElm, StdAnimations.appearPop, '<0.3');
        tl.from(numberElm.querySelector('.abouthead__number span'), StdAnimations.incrementNumber, '<');
    });
}
